import store from '../store';
import { NavigationGuard, RouteRecord, Route, RawLocation } from 'vue-router';
import V from 'vue';
import UserProfile from '@/classes/UserProfile';

export default function authorize(securityLevels: string[]): boolean {
    const role: string | undefined = store.getters.getSecurityLevel;
    if (role) {
        return securityLevels.includes(role);
    } else {
        return false;
    }
}

export function authorizeMap(securityLevel: string): string[] {
  if (Director.includes(securityLevel)) {
    return Director;
  } else if (Office.includes(securityLevel)) {
    return Office;
  } else if (Field.includes(securityLevel)) {
    return Field;
  } else if (Instructor.includes(securityLevel)) {
    return Instructor;
  } else {
    return [];
  }
}

export const Instructor: string[] =
  ['INSTRUCTOR', 'FIELD_COORDINATOR', 'FIELD COORDINATOR', 'GENERAL_OFFICE', 'GENERAL OFFICE', 'DIRECTOR'];

export const Field: string[] =
  ['FIELD_COORDINATOR', 'FIELD COORDINATOR', 'GENERAL_OFFICE', 'GENERAL OFFICE', 'DIRECTOR'];

export const Office: string[] = ['GENERAL_OFFICE', 'GENERAL OFFICE', 'DIRECTOR'];

export const Director: string[] = ['DIRECTOR'];

export const LoginRoute: string = 'login';

export const ResetPasswordRoute: string = 'resetpassword';

export const ForgotPasswordRoute: string = 'forgotpassword';

export const HomeRoute: string = 'home';

export const authorizeRoute: NavigationGuard =
(to: Route, from: Route, next: (to?: RawLocation | false | ((vm: V) => any) | void) => void) => {
    const routeName = to.name ? to.name : '';
    if (![LoginRoute, ResetPasswordRoute, ForgotPasswordRoute].includes(routeName) ) {
      store.dispatch('initializeUserProfile', true)
      .then(() => {
        const authorizedRoute: RouteRecord | undefined = to.matched.find((r) => r.meta.permission !== undefined);
        if (undefined !== store.state.activeProfile && store.state.activeProfile.passwordExpired) {
          next(ResetPasswordRoute);
        } else if (authorizedRoute !== undefined && !authorize(authorizedRoute.meta.permission)) {
          next(HomeRoute);
        } else {
          next();
        }
      })
      .catch(() => {
        store.commit('setAppEntryURL', to.path);
        next(LoginRoute);
      });
    } else {
      next();
    }
  };

export function isOverrideUser(): boolean {
  const currentUser: UserProfile | undefined = store.getters.getActiveProfile;
  if (currentUser !== undefined) {
    return currentUser.override;
  } else {
    return false;
  }
}

export const AuthorizePlugin = {
  install: (Vue: any) => {
    Vue.prototype.$authorize = authorize;
    Vue.prototype.$instructor = Instructor;
    Vue.prototype.$field = Field;
    Vue.prototype.$office = Office;
    Vue.prototype.$director = Director;
    Vue.prototype.$isOverrideUser = isOverrideUser;
  }
};
